import styled from 'styled-components';
export const Container = styled.div`
  position: relative;
  z-index: 999;
`;
export const MenuButtonWrapper = styled.div`
  position: fixed;
  top: 35px;
  right: 15px;
  z-index: 999;
`;
